import clsx from 'clsx'
import Popover from 'components/commons/Popover'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import icMenu from '../../assets/images/ic-menu-01.svg'
import icSetting from '../../assets/images/ic-setting-2.svg'
import hrIcon from '../../assets/images/module-icon/ic-hr.png'

export const FooterSidebar = ({ isCollapse, modules = [], hasCompanySetting }) => {
    const [activeModule, setActiveModule] = useState(null)
    const baseURL = window.location.origin

    useEffect(() => {
        if (modules?.length > 0) {
            const findModule = modules.find((mod) => mod.url === baseURL)
            if (findModule) {
                setActiveModule(findModule)
            }
        }
    }, [modules, baseURL])

    const onSwitchModule = (item) => {
        window.location.href = item.url
    }

    return (
        <>
            <Popover
                className={clsx(
                    'left-none right-0 w-[220px]',
                    isCollapse ? 'module-translate-14' : 'module-translate-80',
                )}
                trigger={
                    <div className='relative flex items-center gap-3 h-9 min-w-9 pr-2.5 mx-2 rounded cursor-pointer bg-primary-10 overflow-hidden'>
                        <img src={hrIcon} alt='module' className='min-w-9 h-9' />
                        {!isCollapse && (
                            <>
                                <p className={'font-bold text-primary-60 truncate'}>{activeModule?.name}</p>
                                <img src={icMenu} alt='menu module' className='ml-auto' />
                            </>
                        )}
                    </div>
                }
            >
                <p className={'px-3 py-2 font-semibold text-primary-50'}>{'Module'}</p>
                {modules.map((module) => (
                    <div
                        onClick={() => onSwitchModule(module)}
                        key={module?.name}
                        className={clsx(
                            'flex gap-2 px-4 py-3 items-center hover:bg-primary-10 hover:text-primary-50 cursor-pointer rounded-lg transition-all duration-200',
                            module?.url === baseURL && 'bg-primary-10 text-primary-50',
                        )}
                    >
                        <img
                            src={module?.icon || hrIcon}
                            className={'w-6 h-6 rounded bg-primary-10'}
                            alt={'module-icon'}
                        />
                        <p>{module?.name}</p>
                    </div>
                ))}
                {hasCompanySetting && (
                    <>
                        <div className='w-full h-px bg-neutral-20 my-2' />
                        <Link to={'/company-settings'}>
                            <div
                                className={
                                    'flex items-center space-x-4 px-4 py-3 cursor-pointer rounded-lg hover:bg-primary-10 hover:text-primary-50'
                                }
                            >
                                <img src={icSetting} className={'w-4 h-4 m-1'} />
                                <p>Settings PT</p>
                            </div>
                        </Link>
                    </>
                )}
            </Popover>
            <p className={clsx('text-xs text-neutral-60 p-4 text-center truncate', isCollapse && 'invisible')}>
                {'AVO 2023 All Right Reserved'}
            </p>
        </>
    )
}
